import { useContext, useState } from "react";
import "./comments.scss";
import { AuthContext } from "../../context/authContext";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../axios";
import moment from "moment";
import { getImageUrl } from "../../utils/getImageUrl"


const Comments = ({ postId }) => {
  const [desc, setDesc] = useState("");
  const {currentUser} = useContext(AuthContext);
  const [sortData, setSortData] = useState([])

  const { isLoading, error, data } = useQuery(["comments"], () =>
    makeRequest.get("/comments?postId=" + postId).then((res) => {
      const dataSort = Object.entries(res.data).sort((a, b) => a[1].createdAt.localeCompare(b[1].createdAt)).map(([_, value]) => value);
      setSortData(dataSort);
      return res.data;
    })
  );

const queryClient = useQueryClient();

const mutation = useMutation(
  (newComment) => {
    return makeRequest.post("/comments", newComment);
  },
  {
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries(["comments"]);
    },
  }
);

const handleClick = async (e) => {
  e.preventDefault();
  mutation.mutate({ desc, postId });
  console.log(desc, postId);
  setDesc("");
};


  return (
    <div className="comments">
      <div className="write">
        {currentUser.profilePic === null
        ?
          <img src={"/defaultProfile.jpg"} alt="" />
        :
          <img src={getImageUrl("profile", currentUser.profilePic)} alt="" />
        }
        <input 
          type="text" 
          placeholder="write a comment"
          value={desc} 
          onChange={(e)=>setDesc(e.target.value)}
        />
        <button onClick={handleClick}>Send</button>
      </div>
      {isLoading 
      ? "loading" 
      : sortData.map((comment)=>(
        <div className="comment" key={comment.id}>
          {comment.profilePic === null
          ?
            <img src={"/defaultProfile.jpg"} alt="" />
          :
            <img src={getImageUrl("profile", comment.profilePic)} alt="" />
          }
          <div className="info">
            <span>{comment.name}</span>
            <p>{comment.desc}</p> 
          </div>
          <span className="date">{moment(comment.createdAt).fromNow()}</span>
        </div>
      ))}
    </div>
  );
};

export default Comments;
